export default __webpack_public_path__ + "static/media/Report.931da6af.svg";